import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { USER_PREFERENCES_SERVICE } from '@eggplant/api-hosts'
import type {
  DataCollectionParams,
  Error,
  GetDataCollectionResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError?: (value: Error) => void
  onSuccess?: (value: GetDataCollectionResponse) => void
  children?: () => ReactElement
  params: DataCollectionParams
}

const PutDataCollectionRequest = ({
  onError,
  onSuccess,
  children,
  params
}: Props) => {
  const url = `${USER_PREFERENCES_SERVICE}/data_collection`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='put'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default PutDataCollectionRequest
